<template>
    <div class="content">
        <div class="my-title">
            <Row :gutter="10">
                <Col :span="18">我的批改单</Col>
                <Col :span="6">
                    <Select v-model="params.bizId" disabled>
                        <Option value="JIANGONG_EMPLOYER_LIABILITY">建工雇主</Option>
                        <Option value="JIANGONG_DEPOSIT">建工投标保证金 </Option>
                    </Select>
                </Col>
            </Row>
        </div>
        <!-- <Tabs v-model="status" @on-click="changeTab">
            <TabPane label="全部" name=" "></TabPane>
            <TabPane label="已提交" name="SUBMITTED"></TabPane>
        </Tabs> -->
        <div class="orders">
            <i-table :columns="columns" url="/broker/insurance/endorse/list.json" :params="params" ref="table">
                <template slot-scope="{ row,index }" slot="action">
                    <!-- <Button type="primary" size="small" style="margin-right: 5px" @click="show(index)">View</Button> -->
                    <!-- <Button type="error" size="small" @click="remove(index)">Delete</Button> -->
                    <!-- <a :href="getAgentUrl(row)" target="_blank">查看</a> -->
                    <a @click="toDetail(row)">查看</a>
                    <!-- <a @click="del(row)">批改</a> -->
                </template>
            </i-table>
        </div>
    </div>
</template>
<script>
    import PolicyItem from '../common/PolicyItem'
    import ITable from '@/components/common/ITable'
    import { mapState } from 'vuex'
    export default {
        components: { PolicyItem, ITable },
        data () {
            return {
                params: {
                    bizId: 'JIANGONG_EMPLOYER_LIABILITY',
                },
                status: ' ',
                columns: [
                    { title: '批改单号', key: 'endorseNo' },
                    { title: '险种', key: 'productName', width: 200 },
                    { title: '保险公司', key: 'insuranceCompanyName', width: 300 },
                    { title: '提交日期', key: 'createTime', width: 180 },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 100,
                        align: 'center'
                    }
                ],
                list: {}
            }
        },
        watch: {
            userInfo (v) {
                this.checkLogin()
            }
        },
        computed: {
            ...mapState({
                userInfo: state => state.common.info
            }),
        },
        created () {
            this.checkLogin()
        },
        methods: {
            changeTab (val) {
                this.status = val
                this.params.endorseStatus = val
                this.$refs.table.getList()
            },
            async toDetail (data) {
                let url = '/agent.html#/agent/review/detail/' + data.endorseId + '?formCustomized=1'
                window.open(url)
            },
            // 检测登录
            checkLogin () {
                if (!this.userInfo.userId) {
                    if (location.href && location.href.indexOf('/common.html#/login') == -1) {
                        window.location = location.origin + '/common.html#/login?bankUrl=' + encodeURIComponent(location.href);
                    }
                    return false
                } else {
                    return true
                }
            }
        }
    }
</script>
<style scoped>
    .content {
        padding: 0 15px 15px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customized/correction.vue